import { FC } from 'react';

import { SpaSelectionWrapper } from './SelectExperienceStep.styles';

import { some } from '@utils/some';
import { useFormContext } from 'react-hook-form';
import { ExperiencesGroup } from '../../components/ExperiencesGroup';
import { SpaTitleWrapper } from '../../components/ExperiencesGroup/ExperiencesGroup.styles';
import { haveAllExperiencesBeenSelected } from '../../helpers/haveAllExperiencesBeenSelected';
import { PackagesFormValues, PackageType } from '../../types';
import { PageTitle } from '../FormSteps.styles';
import { useStepFooter } from '../hooks/useStepFooter';
import { usePackageConfiguration, useWizardNavigation } from '../../contexts';

export const SelectExperienceStep: FC = () => {
  const { journeyParams, packageType } = usePackageConfiguration();
  const { currentFormStep } = useWizardNavigation();

  const { watch } = useFormContext<PackagesFormValues, any>();
  const selectedExperiences = watch('selectedExperiences');
  const totalGuests = journeyParams.adults + journeyParams.children;

  const currentStep = currentFormStep;
  const includedExperiences = (currentStep.selectExperienceOptions || []).filter(
    (option) => option.selectionsRequired === 0
  );

  const selectableExperiences = (currentStep.selectExperienceOptions || []).filter(
    (exp) => exp.selectionsRequired
  );

  const selectableExperiencesByDay = (currentStep.selectExperienceOptionsByDayNumber || []).map(
    (day) => ({
      ...day,
      options: (day?.options || [])
        .filter((option) => option.selectionsRequired)
        .map((option) => ({ ...option, dayNumber: day.dayNumber })),
    })
  );

  const numberOfSelections = (selectedExperiences || [])?.reduce(
    (total, current) => (current.isIncluded ? current.count * totalGuests : current.count) + total,
    0
  );

  const isValid =
    packageType === PackageType.REPEATING
      ? true
      : haveAllExperiencesBeenSelected({
          selectableExperiencesByDay,
          selectedExperiences,
          totalGuests,
          numberOfSelections,
        });

  const footer = useStepFooter({ isValid });

  const groupedIncludedExperiences = some(includedExperiences)
    ? {
        ...includedExperiences[0],
        options: [...new Set(includedExperiences.flatMap((exp) => exp.options || []))],
      }
    : null;
  const repeatableExperiences = some(selectableExperiences)
    ? {
        ...selectableExperiences[0],
        options: [
          ...new Set(selectableExperiences.flatMap((exp) => exp.options || [])),
          ...new Set(includedExperiences.flatMap((exp) => exp.options || [])),
        ],
      }
    : groupedIncludedExperiences;

  return (
    <>
      <SpaSelectionWrapper>
        <div>
          <div>
            <SpaTitleWrapper>
              <PageTitle>Spa</PageTitle>
            </SpaTitleWrapper>
            {packageType === PackageType.REPEATING ? (
              <>
                {repeatableExperiences && (
                  <ExperiencesGroup
                    key={repeatableExperiences?.id}
                    selectionGroup={repeatableExperiences}
                    allOptionsIncluded
                    dayNumber={0}
                  />
                )}
              </>
            ) : (
              <>
                {selectableExperiencesByDay.map((day) => {
                  if (some(day.options)) {
                    return (
                      <>
                        {day.options.map((selectionGroup) => (
                          <ExperiencesGroup
                            key={selectionGroup.id}
                            selectionGroup={selectionGroup}
                            dayNumber={day.dayNumber}
                          />
                        ))}
                      </>
                    );
                  }
                })}

                {groupedIncludedExperiences && (
                  <ExperiencesGroup
                    key={groupedIncludedExperiences?.optionGroupId}
                    selectionGroup={groupedIncludedExperiences}
                    allOptionsIncluded
                    dayNumber={0}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </SpaSelectionWrapper>
      {footer}
    </>
  );
};
